import { render } from "./index.vue?vue&type=template&id=50405196"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

const cssModules = {}
import style0 from "./index.vue?vue&type=style&index=0&id=50405196&lang=scss&module=true"
cssModules["$style"] = style0

import exportComponent from "C:\\Magang\\Digitala\\istry\\web\\frontend\\frontend-istry\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__cssModules',cssModules]])

export default __exports__